import { mapCodeToStore } from 'app/area/codetable/item/mapping/map-code-to-store';
import { RiskMatrixDetails, RiskMatrixDetailsWire } from 'app/area/risk-matrix-administration/types-store';

export const mapDetailsToStore = (detailsWire: RiskMatrixDetailsWire): RiskMatrixDetails => {
  return {
    ...mapCodeToStore(detailsWire),
    xAxisCodetableId: detailsWire.xAxisCodetable,
    yAxisCodetableId: detailsWire.yAxisCodetable,
    zAxisCodetableId: detailsWire.zAxisCodetable,
    xAxisSortOrderType: detailsWire.xAxisSortOrderType,
    yAxisSortOrderType: detailsWire.yAxisSortOrderType,
    zAxisSortOrderType: detailsWire.zAxisSortOrderType
  };
};
